import React, { useState, useEffect, useRef } from 'react';

import { motion } from "framer-motion";

import NaverLogin from 'react-naver-login';
import KakaoLogin from "react-kakao-login";

import { toast } from 'react-toastify';

import * as APIS from "../utils/service";
import { emailMasking, regEmail, regPassword, errorMessage } from "../utils/utils";

import { useLang, usePopup, useUser } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import Image from './Image';
import Input from './Input';
import Button from './Button';
import ContainerLoader from './ContainerLoader';
import SnsLogin from './SnsLogin';

import images from '../libs/images';
import consts from '../libs/consts';

export default function SignUp({ remount, page, setPage }) {

    const emailref = useRef();
    const pwref = useRef();

    const { signPop, closeSignPop } = usePopup();
    const { user, token, login, reload } = useUser();
    
    const [ email, setEmail ] = useState('');
    const [ password, setPassword ] = useState('');

    const [ error, setError ] = useState({});

    const [ load, setLoad ] = useState(false);

    useEffect(() => {

        if(!signPop) closeFunc();

    }, [signPop])
    
    const loginFunc = () => {

        if(!regEmail.test(email)) {
            setError({...error, email: <LangText id={'error_reg_email'}/>});
            emailref?.current?.focus();
            return;
        }

        if(!regPassword.test(password)) {
            setError({...error, password: <LangText id={!password ? 'error_null_pass' : 'error_reg_pass'}/>})
            pwref?.current?.focus();
            return;
        }

        let sender = {
            type: "email",
            email: email,
            pass: password
        }

        console.log('sender', sender);

        APIS.post('/login', sender).then(( { data } ) => {
            console.log('data', data);

            login({ token: data });
    
            closeFunc();

        }).catch(({ response }) => {
            
            // warning
            // warn
            console.log(response);
            
            setLoad(false);
            errorMessage(response?.data);
        });
       
        // setError({...error, password: 'asdaasdsd'})
    }

    const handleKeyDown = (e) => {
        if (e?.key === 'Enter') {
            loginFunc();
        }
    };

    const closeFunc = () => {
        setLoad(false);
        closeSignPop();

        setTimeout(() => {
            setEmail('')
            setPassword('')
            setError({})
        }, 300)
    }

   
    return (
        <div
            className="login_root"
            style={{ display: !page ? 'flex' : 'none'}}
        >
            <ContainerLoader full={true} load={load}/>
            
            {/* <button className='prev_btn' /> */}
            <div className='img' />
            {/* <Image className={['img']} src={images.logo} /> */}
            <p className='title'>
                <LangText id={'btn_login'}/>
            </p>

            <div className='login_form'>
                <Input refs={emailref} name="email" value={email} setValue={setEmail} onKeyDown={handleKeyDown} label={<LangText id={'text_email'}/>} error={error} setError={setError}/>
                <Input refs={pwref} type="password" name="password" value={password} setValue={setPassword} onKeyDown={handleKeyDown} label={<LangText id={'text_pass'}/>} error={error} setError={setError}/>
            </div>
            <div className='find_box'>
                <p onClick={() => setPage('findId')}>
                    <LangText id={'text_find_id'}/>
                </p>
                <span className='bar' />
                <p onClick={() => setPage('findPw')}>
                    <LangText id={'text_find_pass'}/>
                </p>
            </div>

            <Button title={<LangText id={'text_login'}/>} onClick={loginFunc}/>

            <div className='or'>
                <span className='devide'/>
                <p>OR</p>
                <span className='devide'/>
            </div>

            <div className='sns_login_box'>

                {remount && (
                    <SnsLogin type="kakao" onStart={() => setLoad(true)} onEnd={() => setLoad(false)}/>
                )}
                <SnsLogin type="naver" onStart={() => setLoad(true)} onEnd={() => setLoad(false)}/>
                
            </div>
            
            <div className='signin_box'>
                <p>
                    <LangText id={'info_new_id'}/>
                </p>
                <button onClick={() => setPage('signIn')}>
                    <LangText id={'text_registe'}/>
                </button>
            </div>
        </div>
    )    
}